import { useBannerForm } from 'shared/hooks/useBannerForm';
import { IForm } from 'shared/types/form';

type TFindTodayContainerProps = IForm;

export const FindTodayContainer: React.FC<TFindTodayContainerProps> = props => {
  const { backToForm } = props;

  const banner = useBannerForm({ ...props }, backToForm);

  return banner;
};
